import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { type PendingResponse } from '../domain/Tender/PendingResponse'
import { getListOfPendingTenders } from '../use-cases/Tender/getListOfPendingTenders'

type State = {
  pendingResponses: Array<PendingResponse>
  pendingResponsesStatus: RequestStatus
}

function getInitialState(): State {
  return {
    pendingResponses: [],
    pendingResponsesStatus: RequestStatus.Initial,
  }
}

export function usePendingResponses(abortController: AbortController) {
  const [{ pendingResponses, pendingResponsesStatus }, setState] = useState(getInitialState)

  const fetchPendingResponses = useCallback(async () => {
    setState({ ...getInitialState(), pendingResponsesStatus: RequestStatus.Pending })
    try {
      const result = await getListOfPendingTenders(abortController)

      setState({ pendingResponses: result, pendingResponsesStatus: RequestStatus.Done })
    } catch (error) {
      if (!abortController.signal.aborted) {
        setState({ pendingResponses: [], pendingResponsesStatus: RequestStatus.Error })
        sentry.log(error)
      }
    }
  }, [abortController])

  return {
    pendingResponses,
    pendingResponsesStatus,
    fetchPendingResponses,
  }
}
